import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import variationState from './variations/state'
import variationActions from './variations/actions'
import variationGetters from './variations/getters'
import variationMutations from './variations/mutations'
import attributeState from './attributes/state'
import attributeActions from './attributes/actions'
import attributeGetters from './attributes/getters'
import attributeMutations from './attributes/mutations'
import cookiesModule from '../cookies/store/cookiesModule'
import cartProductCustomizationsModule from './cartProductCustomizations/cartProductCustomizationsModule'
import productChartModule from './productChart/productChartModule'

Vue.use(Vuex)

export default new Vuex.Store({
  state: { ...state, ...variationState, ...attributeState },
  getters: { ...getters, ...variationGetters, ...attributeGetters },
  actions: { ...actions, ...variationActions, ...attributeActions },
  mutations: { ...mutations, ...variationMutations, ...attributeMutations },
  modules: {
    cookies: cookiesModule,
    cartProductCustomizations: cartProductCustomizationsModule,
    productChart: productChartModule
  }
})
